import React from 'react'
import { Drawer } from 'antd'

import { stringifyDate, useListData } from '../../modules'

import Receive from '../reusable/receive'

const InsurerLedger = ({ visible, insurer, onClose }) => {
    const [
        { loading, error },
        { list: entries = [], data },
        { Paginate }
    ] = useListData('insurerReceivableLedger', { insurer: insurer?._id }, { notify: true }, 'entries')

    const close = () => onClose()

    return (
        <Drawer
            closable
            maskClosable
            visible={ visible }
            onClose={ close }
            width="50%">
            <div className="flex justify-between">
                <p className="font-extrabold text-3xl mb-0">{ insurer?.name ?? 'Insurer Ledger' }</p>
                <div className="flex flex-col items-end pr-3 py-3">
                    <p className="font-semibold text-lg underline mb-2">Overview</p>
                    <p className="mb-1">Current Balance: Ksh. { Number(data?.balance ?? 0).toLocaleString() }</p>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white">
                <Receive error={ error } loading={ loading } progress>
                    {
                        entries.length > 0 ?
                            <table className="table-auto w-full">
                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                    <tr>
                                        <th className="p-2"><div className="font-semibold text-center">No</div></th>
                                        <th className="p-2"><div className="font-semibold text-left">Date</div></th>
                                        <th className="p-2"><div className="font-semibold text-left">Notes</div></th>
                                        <th className="p-2"><div className="font-semibold text-left">Amount</div></th>
                                        <th className="p-2"><div className="font-semibold text-left">Balance</div></th>
                                    </tr>
                                </thead>
                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                    {
                                        entries.map((entry, key) =>
                                            <tr key={ entry._id }>
                                                <td className="p-2"><div className="text-center">{key + 1}</div></td>
                                                <td className="p-2">
                                                    <div>{stringifyDate(entry?.date)}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className="text-xs">{entry?.notes}</div>
                                                </td>
                                                <td className="p-2">
                                                    <div className={ entry?.amount < 0 ? 'text-red-600' : 'text-green-600' }>
                                                        {entry?.amount < 0 ? '-' : '+'}{Number(Math.abs(entry?.amount ?? 0)).toLocaleString()}
                                                    </div>
                                                </td>
                                                <td className="p-2">
                                                    <div>{Number(entry?.newBalance ?? 0).toLocaleString()}</div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                            :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">No ledger entries were found</p>
                            </div>
                    }
                </Receive>
                {Paginate}
            </div>
        </Drawer>
    )
}

export default InsurerLedger
